import styled from "styled-components";
import StyledSection from "../Common/Section.styled";

const StyledSkills = styled(StyledSection)`
 
`

export default StyledSkills;